<template>
    <v-alert
        outlined
        color="error"
        class="d-inline-block mb-0"
    >
        <v-subheader
            class="pl-0 mt-2"
            style="height: auto;"
        >
            <strong>
                {{ header_text }}
            </strong>
        </v-subheader>

        <v-list
            color="transparent"
            style="background: transparent;"
            class="d-flex flex-column gap-2"
            dense
        >
            <v-list-item
                v-for="(item, index) in reasons"
                :key="index"
            >
                <v-list-item-icon class="my-0 mr-1">
                    <v-icon
                        color="error"
                        aria-hidden="true"
                        small
                    >
                        mdi-alert-circle-outline
                    </v-icon>
                </v-list-item-icon>

                <v-list-item-content class="pa-0">
                    <v-list-item-subtitle
                        class="primary--text"
                        style="font-size: 14px;"
                    >
                        {{ item.text }}

                        <a
                            v-if="item.help_text"
                            class="secondary--text"
                            style="text-decoration: underline;"
                            @click="showHelpAlert(item)"
                        >
                            help
                        </a>

                        <v-btn
                            v-else-if="item.target"
                            color="primary"
                            class="ml-2"
                            outlined
                            x-small
                            @click="onFixItem(item)"
                        >
                            Fix It
                        </v-btn>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-alert>
</template>

<script>
import GuidedValidationMixin from '@/mixins/guided-validation.js';

export default {
    name: 'StepValidation',

    mixins: [GuidedValidationMixin],

    props: {
        /**
         * Array of objects with 'text' and 'help_text' (optional) properties.
         */
        reasons: {
            type: Array,
            required: true,
            default: () => []
        },
        /**
         * Header text to display above the validation list.
         */
        header_text: {
            type: String,
            required: false,
            default: 'To continue, please fix the following:'
        },
    },

    methods: {
        showHelpAlert(item) {
            this.$rc.alert(
                'Unable to Proceed',
                item.help_text,
            );
        },

        onFixItem(item) {
            if (item.target) {
                this.mixinGuideToFix({ location: { target: item.target } });
            }
        },
    }
};
</script>

<style lang="scss" scoped>
:deep(.v-list-item) {
    min-height: unset !important;
}
</style>
